import React from 'react'

const MovieBadget = props => {
  // props for this file from parent
  const { sendBooleanValueChangeDone, sendBudget, modeUrl, Budget, editData, active } = props
  // state variables for this file
  const indication = modeUrl
    ? editData.Budget === Budget || active.Budget === 'TRUE'
      ? { borderColor: 'green' }
      : { borderColor: 'red' }
    : ''
  // function to handle change in Budget and send to parent
  const budget = event => {
    sendBooleanValueChangeDone('budget', true)
    sendBudget('Budget', event.target.value)
  }

  return (
    <div>
      <div>
        <label>Budget:</label>
        <input
          className='form-control'
          type='text'
          placeholder='please enter budget'
          value={Budget}
          style={modeUrl && indication}
          onChange={event => budget(event)}
        />
      </div>
    </div>
  )
}

export default MovieBadget
